import ClientStatements from './ClientStatements';

export default ClientStatements;